import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {AlarmOutlined,AirportShuttleOutlined,SubwayOutlined,Send,AirlineSeatReclineNormal,Money,AirportShuttle,PersonOutlined,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place,WbIncandescentOutlined,ArrowDropDown,DevicesOtherOutlined,AccountBalanceWalletOutlined,ConfirmationNumberOutlined,CancelPresentation} from '@material-ui/icons';

import ScheduleIcon from '@material-ui/icons/Schedule';

import {
  ListItemText,
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Grid,
  Chip,
  Link ,
  useMediaQuery,
  ListItemIcon,
  List,
  ListItem,
  ListSubheader
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import { MuiPickersUtilsProvider, DatePicker,TimePicker,KeyboardTimePicker, DateTimePicker} from "@material-ui/pickers";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';


import UserInfo from "./login_info";

import axios from 'axios';
import Format from "date-fns/format";
import DateFnsUtils from "@date-io/date-fns";

import {TransportService,ReportingService} from "./../../utils/web_config_2";
import { set } from 'date-fns/esm';
import Manifesto from "../../assets/svg/bus-stop.svg";
import bus from "../../assets/svg/bus.svg";
import route from "../../assets/svg/route.svg";

import passenger from "../../assets/svg/passenger_bus.svg";
import money from "../../assets/svg/total_amount.svg";
import iticketdetails from "../../assets/svg/ticket_details.svg";

import Chart from 'react-apexcharts';




const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},paper: {
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height:120,
  elevation:0
},
paper1: {
  color: theme.palette.text.secondary,
  height:240,
  elevation:0
}
}));




function ManifestoReport() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

 
  const [operatorData, setOperatorData] = useState({});
  var React = require('react');
  var QRCode = require('qrcode.react');
  const Theme = useTheme();
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  const [scheduleMessage,setScheduleMessage]=useState("Loading...");

  // overview  table 

  const [scheduleInfo,setScheduleInfo]=useState({});

  const [open,setOpen]=useState("schedule");

const columns = [
    {
        name: "id",
        label:"Bus",
        options: {
         filter: true,
         sort: true,  
         customBodyRender: (value, tableMeta, updateValue) => {
           var obj=schedules.find((o)=>o['id']==value);
          
           var pl=obj['vehicle']!=null?obj['vehicle']['number_plate']:"";
         return(
         <Typography><Link href="#" onClick={()=>{
           setScheduleInfo(obj);
           var dat=new Date(obj['scheduled_on_date_time']);
          get_report(pl,Format(dat, ["yyyy-MM-dd HH:mm",]),obj['route']);
         }}>{pl}</Link></Typography>
         )
       }
        
        }
    },
  {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "scheduled_on_date_time",
   label:"Departure Date/Time",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "total_sold_seats",
    label:"Total sold tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
    name: "scheduling_mode",
    label: "Scheduling Mode",
    options: {
     filter: true,
     sort: true,
    }
   },
 ];



 const options = {
  textLabels: {
    body: {
      noMatch: scheduleMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0
 };





  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setOperatorData(data);
    
    get_schedules(data.token,Format(new Date, ["yyyy-MM-dd",]));
    
  },[]);

  
  // business overview

  const [totalTickets,setTotalTickets]=useState(0);
  const [totalAmount,setTotalAmount]=useState(0);
  const [plateNumber,setPlateNumber]=useState({value:"",error:""});
  const [departuteTime,setDeparture]=useState({value:"",error:""});

  const [stops,setStops]=useState([]);
  const [values,setValues]=useState([]);

  const [reports,setReports]=useState([]);
  const [reportLoad,setReportLoad]=useState(false);
  const get_report=(p,d,r)=>{
    
    setReportLoad(true);
    setOpen("details");
    setReports([]);
    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    reportInstance.post('/traffic-report/manifesto-report',{
      "plate_number": p,
      "organization_id": new UserInfo().ORG_ID,
      "departure_time": d,
      "route": r
  })
  .then(res=>{
    var objs=res.data.data;
    var st=[];
    var vl=[];
    if(objs.length==0){
      setDetailsMessage("No report available");
    }
    let t=objs.length;
    setTotalTickets(t);
    let a=0;
    objs.map((o)=>{
      a=a+parseInt(o['price']);
      st.push(o['source']);
    });
    st=st.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);

    st.map((s)=>{
      let i=0;
      objs.map((o)=>{
        if(o['source']==s){
          i++;
        }
      });
      vl.push(i);
    });

    setStopChart({
          
      series: vl,
      options: {
        chart: {
          width: 400,
          type: 'pie',
          height:380
        },
        labels: st,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width:"100%"
            },
            legend: {
              position: 'right'
            }
          }
        }]
      },
    });
  

    setTotalAmount(a);
    setReports(objs);
    setReportLoad(false);
  })
  .catch(err=>{
    setReportLoad(false);
  });

  }




  // format money 
  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };

  // get all schedules

  const [day,setDay]=useState({value:Format(new Date, ["yyyy-MM-dd",]),error:""});



  const [schedules,setSchedules]=useState([]);
  const [scheduleLoad,setScheduleLoad]=useState(false);
  const get_schedules=(token,d)=>{
    setSchedules([]);
    setScheduleLoad(true);
    setScheduleMessage("Loading...");
    const schedulesInstance = axios.create(new TransportService().setHeaders(token));
    schedulesInstance.put(new TransportService().GET_DAILY_SCHEDULE,{
      "end_date": d,
      "operator_id":new UserInfo().ID,
      "start_date": d
    })
    .then(res=>{
      console.log("res",res.data);
      var objs=res.data;
      var n_objs=[];
      if(objs.length==0){
        setScheduleMessage("No schedules available");
      }else{
        objs.map((o)=>{
          
          o['route']=o['route']['name'];
          if(o['vehicle']!=null){
            n_objs.push(o);
          }
        });
        if(n_objs.length==0){
          setScheduleMessage("No schedules available");
        }
        setSchedules(n_objs);
      }
      setScheduleLoad(false);
    })
    .catch(err=>{
      setScheduleLoad(false);
    }); 
  }


  



  // details report 

  const [detailsMessage,setDetailsMessage]=useState("Loading");



  const [stopChart,setStopChart]=useState({
          
    series: [],
    options: {
      chart: {
        width: 400,
        type: 'pie',
        height:380
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width:"100%"
          },
          legend: {
            position: 'right'
          }
        }
      }]
    },
  
  
  });

  // details table 

  const columnsDetails = [
    {
      name: "ticket_id",
      label:"Number",
      options: {
       filter: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
        return(
        <Typography><Link href="#" onClick={()=>{
          var obj=reports.find((r)=>r.ticket_id==value);
          setTicketData(obj);
          setTicketDialog(true);
        }}>{value}</Link></Typography>
        )
      }
      }
  },
    {
        name: "customer_full_names",
        label:"Customer name",
        options: {
         filter: true,
         sort: true,
        }
    },
  {
    name: "phone_number",
    label: "Phone number",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "source",
   label:"Source",
   options: {
    filter: true,
    sort: true,
   }
  },{
    name: "destination",
    label:"Destination",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "currency",
    label:"Currency",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "price",
    label:"Price",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
    return(
    <Typography>{formatMoney(parseFloat(value))}</Typography>
    )
  }
    }
   },
   {
    name: "seat_number",
    label:"Seat number",
    options: {
     filter: true,
     sort: true,
    }
   }
 ];



 const optionsDetails = {
  textLabels: {
    body: {
      noMatch: detailsMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0
 };


 /// ticket details

const [ticketDialog,setTicketDialog]=useState(false);
const [ticketData,setTicketData]=useState({});


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><img src={Manifesto} width="40px" height="40px"/> </Box> <Typography  variant="h5" color="default"><b>Manifesto Report</b></Typography>

 </Box>
{open=="details"&&
 <IconButton width="50px" height="50px" onClick={()=>{
  setOpen("schedule");
   }}>
  <CancelPresentation style={{color:"red"}} />
   </IconButton>  
}


 
     </Box>

{open=="schedule"&&


<Grid container spacing={1}>

{/* total tickets  */}

     {/* <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Buses</Typography></Box>
  <Box mt={2}><Typography variant="h5" className={classes.title}>{0}</Typography></Box>
           
          </Grid>

          <Grid item xs={6} md={6}>
            <img src={bus} width="70px" height="70px"/>
          </Grid>

          </Grid>
          </Paper>
          </Grid> */}




{/* <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Routes</Typography></Box>
  <Box mt={2}><Typography variant="h5" className={classes.title}>0</Typography></Box>
            
          </Grid>
          <Grid item xs={6} md={6}>
            <img src={route} width="70px" height="70px"/>
          </Grid>

          </Grid>
          </Paper>
          </Grid> */}



          {/* <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Channels</Typography></Box>
            <Box mt={2}><Typography variant="h5" className={classes.title}>4</Typography></Box>
          </Grid>
          <Grid item xs={6} md={6}>
            <DevicesOtherOutlined style={{width:"80px",height:"80px"}} color="primary"/>
          </Grid>

          </Grid>
          </Paper>
          </Grid> */}


       <Grid item xs={12} sm={12} md={12} lg={12}>
 {/* overview table table  */}

 <Box mt={0}>
 {scheduleLoad&&<LinearProgress />}
 <MUIDataTable
  title={<Box  display="flex"><Box  >
  <DatePicker
  style={{height:50}}
    fullWidth
    variant="inline"
    format="yyyy-MM-dd"
    margin="dense"
    autoOk
    label="Date"
    value={day.value}
    inputVariant="outlined"
    onChange={(v)=>{
     
     setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
 
     get_schedules(operatorData.token,Format(v, ["yyyy-MM-dd",]));
 
    }}
    InputProps={{
      disableUnderline: true,
      style: { paddingRight: 0 },
    }}
  />
 </Box></Box>}
  data={schedules}
  columns={columns}
  options={options}
/>
 </Box> 
       </Grid>
     </Grid>



}



{open=="details"&&

<Grid container spacing={1}>



     <Grid item xs={12} md={4} lg={4} sm={4} >
       <Grid container spacing={1}>
         {/* total tickets  */}
         <Grid item xs={12} sm={12} md={12} lg={12}>
         <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Passengers</Typography></Box>
  <Box mt={2}><Typography variant="h5" className={classes.title}>{totalTickets}</Typography></Box>
           
          </Grid>

          <Grid item xs={6} md={6}>
            <img src={passenger} width="70px" height="70px"/>
          </Grid>

          </Grid>
          </Paper>
         </Grid>
         {/* total amount  */}
         <Grid item xs={12} sm={12} md={12} lg={12}>
         <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Total Amount</Typography></Box>
<Box mt={2}><Typography variant="h5" className={classes.title}>{formatMoney(parseInt(totalAmount),0)}</Typography></Box>
            
          </Grid>
          <Grid item xs={6} md={6}>
            <img src={money} width="70px" height="70px"/>
          </Grid>

          </Grid>
          </Paper>
         </Grid>
       </Grid>
           

          </Grid>



{/* stop chart */}


<Grid item xs={12} md={5} lg={5} sm={5} >

       <Paper className={classes.paper1} elevation={0}>  

<Chart options={stopChart.options} series={stopChart.series} type="pie" width={350} height={380} />
</Paper> 
          </Grid>


          <Grid item xs={12} md={3} lg={3} sm={3} >

       <Paper className={classes.paper1} elevation={0}>  

       <List
       dense
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          Schedule Info
        </ListSubheader>
      }
    >
      <ListItem dense >
        <ListItemIcon>
          <SubwayOutlined />
        </ListItemIcon>
        <ListItemText primary={scheduleInfo['route']} />
      </ListItem>


      <ListItem dense >
        <ListItemIcon>
          <PersonOutlined />
        </ListItemIcon>
        <ListItemText primary={scheduleInfo['driver']['first_name']+" "+scheduleInfo['driver']['last_name']} />
      </ListItem>
     

      <ListItem dense >
        <ListItemIcon>
          <AirportShuttleOutlined />
        </ListItemIcon>
        <ListItemText primary={scheduleInfo['vehicle']['number_plate']} />
      </ListItem>

      <ListItem dense >
        <ListItemIcon>
          <AlarmOutlined/>
        </ListItemIcon>
        <ListItemText primary={scheduleInfo['scheduled_on_date_time']} />
      </ListItem>

        </List> 

        </Paper> 
        </Grid>




       <Grid item xs={12} sm={12} md={12} lg={12}>
 {/* overview table table  */}

 <Box mt={0}>
 {reportLoad&&<LinearProgress />}
 <MUIDataTable
  title={"Tickets"}
  data={reports}
  columns={columnsDetails}
  options={optionsDetails}
/>
 </Box> 
       </Grid>
     </Grid>


}

    </div>


{/* ticket details  */}


    <Dialog
    maxWidth="sm"
    fullWidth
        open={ticketDialog}
        onClose={()=>{
          setTicketDialog(false);
          setTicketData({});
        }
      }
        aria-labelledby="ticket_details"
        aria-describedby="ticket_details"
      >
        <DialogTitle id="ticket_details">{"Ticket details"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
         
         <Box>


           <Grid container>
             <Grid item xs={12} md={6} lg={6} sm={6}>
             <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
        <QRCode value={ticketData.ticket_id!=undefined&&ticketData.ticket_id} size={100}/>
        </Box>
        <Box display="flex" justifyContent='center'  >
<List >
<ListItem dense >
            <ListItemIcon>
              <PersonOutlined/>
            </ListItemIcon>
    <ListItemText primary={<b>{ticketData.customer_full_names!=undefined&&ticketData.customer_full_names}</b>} />
          </ListItem>

<ListItem dense >
            <ListItemIcon>
              <AirportShuttle/>
            </ListItemIcon>
    <ListItemText primary={<b>{ticketData.source!=undefined&&ticketData.source+"-"+ticketData.destination}</b>} />
          </ListItem>

          <ListItem dense >
            <ListItemIcon>
              <ScheduleIcon/>
            </ListItemIcon>
    <ListItemText primary={<b>{ticketData.departure_time!=undefined&&ticketData.departure_time}</b>} />
          </ListItem>

          <ListItem dense >
            <ListItemIcon>
              <Money/>
            </ListItemIcon>
    <ListItemText primary={<b>{ticketData.price!=undefined&&ticketData.price} {ticketData.currency!=undefined&&ticketData.currency}</b>} />
          </ListItem>

          <ListItem dense >
            <ListItemIcon>
              <AirlineSeatReclineNormal/>
            </ListItemIcon>
    <ListItemText primary={<b>{ticketData.seat_number!=undefined&&ticketData.seat_number}</b>} />
          </ListItem>
          
</List>
        </Box>

             </Grid>
             {matches&& <Grid item xs={12} md={6} lg={6} sm={6}>
               <img src={iticketdetails} />
               </Grid>}
           </Grid>

         </Box>
         
         
           </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            setTicketDialog(false);
            setTicketData({});
          }} variant="outlined" color="secondary" autoFocus>
            Close
          </Button>
         
        </DialogActions>
      </Dialog>


    

    </MuiPickersUtilsProvider>
  );
}

export default  withLocalize(ManifestoReport);